class Nfes {
    static get $inject() {
        return ['$uibModal', 'gql']
    }

    constructor(modal, gql) {
        this.modal = modal
        this.gql = gql
    }

    downloadXlsx(empresaId, filter, nfes = []) {
        this.modal.open({
            backdrop: 'static',
            component: 'nfeXlsxFields',
            size: 'lg',
            resolve: {
                nfes: () => nfes,
                filter: () => filter,
                contratoId: () => empresaId
            }
        })        
    }

    downloadDanfe(filialId, chave) {
        this.downloadOperation(this.fetchTokenNfe(filialId, 'DownloadNfeDa', chave, 'danfe'))
    }

    async downloadOperation(tokenPromise) {
        let tab = cbk.initDownloadTab();
        let token = await tokenPromise
        cbk.download(`/api/resume-operation/${token}`, tab)
    }

    async fetchTokenNfe(filialId, operation, chave, format) {
        const query = gql`
            query ${operation}($filialId: Int!, $filter: NfeFilter!) {
                filial(id: $filialId) {
                    id
                    nfe(filter: $filter) {
                        ${format} { token }
                    }
                }
            }
        `

        let { filial: { nfe } } =
            await this.gql.query(query, { filialId, filter: { chave } })

        return nfe[format]['token']
    }
}

angular.module('eficienciaFiscalModule').service('Nfes', Nfes)
